import { Type, PenTool, Calendar, CheckSquare, Edit3, Hash, ChevronDown } from "lucide-react";

export const FIELD_TYPES = [
    { id: "text", label: "Text Field", Icon: Type, dw: 200, dh: 18 },
    { id: "signature", label: "Signature", Icon: PenTool, dw: 220, dh: 72 },
    { id: "date", label: "Date", Icon: Calendar, dw: 150, dh: 36 },
    { id: "checkbox", label: "Checkbox", Icon: CheckSquare, dw: 24, dh: 24 },
    { id: "initials", label: "Initials", Icon: Edit3, dw: 80, dh: 44 },
    { id: "number", label: "Number", Icon: Hash, dw: 120, dh: 36 },
    { id: "dropdown", label: "Dropdown", Icon: ChevronDown, dw: 180, dh: 36 },
];

export const ROLE_PALETTE = [
    { bg: "#dbeafe", border: "#3b82f6", text: "#1e40af", dot: "#3b82f6" },
    { bg: "#d1fae5", border: "#10b981", text: "#065f46", dot: "#10b981" },
    { bg: "#fef3c7", border: "#f59e0b", text: "#92400e", dot: "#f59e0b" },
    { bg: "#fee2e2", border: "#ef4444", text: "#991b1b", dot: "#ef4444" },
    { bg: "#f3e8ff", border: "#a855f7", text: "#6b21a8", dot: "#a855f7" },
    { bg: "#cffafe", border: "#06b6d4", text: "#155e75", dot: "#06b6d4" },
];

export const ACCENT = "#dc2626";
export const PDF_W = 595;
export const PDF_H = 842;